<mat-dialog-content>
  <form [formGroup]="declarantRateForm">
    <div class="row">
      <div class="col-md-3">
        <span>{{ 'tributary.declarantRate.labels.type' | translate }}:</span>
        <select class="form-control" formControlName="id_declarant">
          <option selected value="">
            {{ 'tributary.declarantRate.labels.selectType' | translate }}
          </option>
          @for (declarant of declarantTypesList; track declarant.id_declarant) {
            <option [ngValue]="declarant.id_declarant">
              {{ declarant.name | translate }} -
              {{ declarant.type | translate }}
            </option>
          }
        </select>
        @if (textValid('id_declarant')) {
          <span class="form-text text-danger">{{
            'tributary.declarantRate.validation.typeRequired' | translate
          }}</span>
        }
      </div>
      <div class="col-md-3">
        <span>{{ 'Type' | translate }}:</span>
        <select class="form-control" formControlName="id_type">
          <option selected value="">{{ 'Select type' | translate }}</option>
          @for (type of typesList; track type.id_type) {
            <option [ngValue]="type.id_type">
              {{ type.description }}
            </option>
          }
        </select>
        @if (textValid('id_type')) {
          <span class="form-text text-danger">{{
            'You must select a type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-3">
        <span>{{ 'Value' | translate }} (%):</span>
        <input
          class="form-control"
          type="number"
          placeholder="{{ 'Value' | translate }}"
          formControlName="value"
          min="0"
          step="0.01"
        />
        @if (textValid('value')) {
          <span class="form-text text-danger">{{
            'tributary.declarantRate.validation.valueRequired' | translate
          }}</span>
        }
      </div>
      <div class="col-md-3">
        <span>UVT:</span>
        <input
          class="form-control"
          type="number"
          placeholder="UVT"
          formControlName="uvt"
          min="0"
          step="0.01"
        />
        @if (textValid('uvt')) {
          <span class="form-text text-danger">{{
            'tributary.common.uvtRequired' | translate
          }}</span>
        }
      </div>
    </div>
    <div class="row dialog-actions">
      <div class="col action-button">
        <button (click)="register()" mat-raised-button>
          {{ 'Register' | translate }}
        </button>
      </div>
      <div class="col action-button">
        <button mat-raised-button [mat-dialog-close]>
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p class="spinner-message">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
